<template>
    <div class="special-detail-poster">
      <h2>分享海报</h2>
      <div class="poster-box">
        <img :src="baseInfo.posterUrl" alt />
        <div class="poster-box-contain">
          <p>{{baseInfo.productName}}</p>
          <div class="price">
            <span>￥</span>
            {{startPrice}}
            <span>起</span>
          </div>
        </div>
        <div class="poster-share" @click="sharePoster"></div>
      </div>
      <div class="more">
        <div class="more-item" v-if="baseInfo.posterCount > 1" @click="handle4MoreMaterialLocation(1)">
          更多热门海报
          <em>（{{baseInfo.posterCount}}）</em>
        </div>
        <div class="more-item" v-if="baseInfo.contentCount" @click="handle4MoreMaterialLocation(2)">
          更多发圈素材
          <em>（{{baseInfo.contentCount}}）</em>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'sharePoster',
    data() {
        return {
        }
    },
    props: {
      shareImageData: {
          type: Object,
          default: () => ({})
      }
    },
    computed: {
        ...mapState({
            baseInfo: state => state.detail && state.detail.baseInfo,
            startPrice: state => state.startPrice
        }),
    },
    methods: {
        handle4MoreMaterialLocation(tabId) {
          //点评内页
          let params = {
            rctModuleName: "tekMaterialForSearch",
            rctModule: "tekrndetail",
            rctModuleParams: {
              productId: this.baseInfo.productId,
              tabId
            }
          };
          let openUrl = `tntweeker://page?iosPageName=TNReactNativeViewController&androidPageName=com.tuniu.tweeker.rn.TNReactNativeActivity&parameters=${encodeURIComponent(
            JSON.stringify(params)
          )}`;
          location.href = openUrl;
        },
        sharePoster() {
            const content = this.baseInfo.productName;
            const posterUrl = this.baseInfo.posterUrl;
            let shareImageData = '';
            if(this.shareImageData.productId && this.shareImageData.productId == this.baseInfo.productId) {
              shareImageData = this.shareImageData.imageData;
            }
            const mallPath = `/mall/pages/details?productId=${this.baseInfo.productId}`;
            if (window.G && window.G.webviewBridgeReady) {
                window.G.webviewBridgeReady(bridge => {
                    bridge.callHandler('share', {
                        // shareType: 3,
                        title: content,
                        content,
                        url: window.location.href,
                        shareWxAppId: "gh_53e4d148c0a4",
                        wxProgramImageURL: posterUrl,
                        wxProgramImageBase64: shareImageData,
                        wxProgramDesc: content,
                        wxProgramPath: mallPath,
                        imageurl: posterUrl,
                        bigImageBitmapBase64: shareImageData,
                        shareProductId: this.baseInfo.productId,
                        shareProductType: this.baseInfo.classBrandParentId || '',
                        shareCategory: this.baseInfo.classBrandName || '',
                        bookCityCode: this.baseInfo.bookCityCode
                    }, null)
                })
            }
        }
    }
}
</script>

<style lang="scss">
    .special-detail-poster {
      background: #fff;
      border-radius: 18px;
      padding: 15px;
      margin-top: 10px;
      margin-bottom: 10px;
      h2 {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-bottom: 15px;
      }
      .poster {
        &-box {
          position: relative;
          background: #fff;
          box-shadow: 0 5px 20px 0 rgba(118, 118, 118, 0.1);
          border-radius: 12px;
          height: 130px;
          display: flex;
          flex-direction: row;
          overflow: hidden;
          img {
            height: 100%;
            width: auto;
          }
          &-contain {
            padding: 13px 15px 16px;
            display: flex;
            flex-direction: column;
            p {
              font-size: 13px;
              color: #666;
              line-height: 18px;
              flex: 1;
            }
            .price {
              font-size: 16px;
              color: #333;
              font-weight: bold;
              span {
                font-size: 12px;
                margin: 0 2px;
                &:last-child {
                  font-weight: 300;
                }
              }
            }
          }
        }
        &-share {
          border-radius: 18px;
          width: 44px;
          height: 30px;
          position: absolute;
          right: 18px;
          bottom: 11px;
          background: url(//m.tuniucdn.com/fb2/t1/G5/M00/5F/04/Cii-tFxOlg2IJPzRAAACXKGJBKYAATlzQP__YwAAAJ0316.png)
            #ff3939 no-repeat center;
          background-size: 14px 14px;
        }
      }
    }
    .more {
      display: flex;

      .more-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 19px;
        border-left: 1px solid rgba(151, 151, 151, 0.4);
        font-size: 14px;
        color: #666666;

        em {
          color: #32c45d;
        }

        &:first-child {
          border: 0;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// sharePoster.vue